import React, { useState } from 'react'
import { db } from '../../firebase.js'

function RoomStatus(props) {
  async function lockRoom(roomId) {
    try {
      let ref = db.ref(props.roomId + '/lastLogin')
      ref.set(false)
      alert('This room has been successfully locked.  The user will have to enter their key next time they visit')
    } catch{
      alert('An error occured.  Please contact your devs')
    }
    // ref.on('value', (snapshot) => {
    //   console.log('data: ' + ref.set(newState))
    //   return newState
    // })
  }

  return(
    <button
    className='admin-panel-unlocked-button'
    onClick={() => lockRoom(props.roomId)}
    >
      Lock Room
    </button>
  )
}

export default RoomStatus
